export const dropOffPointTitle = 'Entrega en punto de recogida'

export const yourDropOffPointTitle = 'Tu punto de recogida'

export const selectDropOffPointExplanation = 'Selecciona el punto de recogida que mejor te venga'

export const editDropOffPointExplanation =
  'Edita tu selección para explorar otros puntos de recogida que te vengan mejor.'

export const editDropOffPoint = 'Editar punto de recogida'

export const buttonVariants = {
  contained: 'contained',
  outlined: 'outlined',
}
